<template>
<div class="field is-horizontal">
  <div class="field-body">
    <field :label="label">
      <div class="field has-addons">
        <div class="control"><div class="button is-static">$</div></div>
          <text-field :placeholder="placeholder" v-model="val"
          class="control is-expanded" :class="{ 'margin-loss': error !== null }"
          @blur="onBlur" :error="error"/>
        </div>
    </field>
  </div>
</div>
</template>

<script>
import Field from '@/components/general/field'
import TextField from '@/components/general/text-field'

export default {
  components: { Field, TextField },
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    error: {
      type: String,
      default: null
    }
  },
  computed: {
    val: {
      get () {
        if (this.value !== null &&
        this.value.length === parseInt(this.value).toString().length) {
          return parseInt(this.value).toLocaleString()
        } else return this.value
      },
      set (stringValue) {
        if (stringValue === '') this.value = 0
        else {
          stringValue = stringValue.replace(/,/g, '')
          this.$emit('input', stringValue)
        }
      }
    }
  },
  methods: {
    onBlur (event) {
      this.$emit('blur', event)
    }
  }
}
</script>

<style lang="scss" scoped>
.margin-loss {
  margin-top: 0
}
</style>



// WEBPACK FOOTER //
// src/components/general/currency-text-field.vue